// extracted by mini-css-extract-plugin
module.exports = {"info-modal":"InfoModal_info-modal__8l-wV","modal-content":"InfoModal_modal-content__SAO0Y"};